// Módulos de "Gestión" (mismo grupo que el dropdown "Gestión" del menú
// lateral, ver AdminMenu.js) — usado por ManagementModuleTitle para armar
// el selector de módulo en el encabezado de cada página, sin depender del
// menú lateral.
export const MANAGEMENT_MODULES = [
  { path: "/admin/annual-plan",        labelKey: "annual_plan" },
  { path: "/admin/legal-requirements", labelKey: "legal_requirements" },
  { path: "/admin/accidents",          labelKey: "accident_management" },
  { path: "/admin/eval-riesgos",       labelKey: "ra_title" },
  { path: "/admin/work-permits",       labelKey: "work_permits" },
  { path: "/admin/action-plans",       labelKey: "action_plan_management" },
];
